export enum POPUP_CLICK_TYPE {
    CLOSE_POPUP = 'closePopup',
    UPDATE_CONTACT = 'updateContact',
    UPDATE_INVOICE = 'updateInvoice',
    UPDATE_QUOTE = 'updateQuote',
    UPDATE_BILL = 'updateBill',
    UPDATE_ORDER = 'updateOrder',
    ADD_SEQUENCE_FORMAT = 'addSequenceFormat',
    SAVE_CUSTOM_DOCUMENT_NUMBER = 'saveNumber'
}

export enum POPUP_TYPE  {
    POPUP = 'popup',
    DRAFT = 'draft'
}

export enum PAYROLL_FIELD_KEY_NAMES {
    PAY_SCHEDULE = "paySchedule",
    TYPE = "type",
    COMPONENTS = "component",
    BENEFIT = "benefit",
    PAY_PERIOD = "payPeriod",
    PAY_DAY = "payDay",
    PAY_DATE = "payDate",
    WORK_PERIOD = "workPeriod",
    APPLICABLE_TO = "applicableTo"

}

export enum DropdownSelectionType {
    SINGLE = 'single',
    MULTIPLE = 'multiple'
}

export enum FORM_ELEMENTS {
    DROPDOWN = 'dropdown',
    INPUT = 'input',
    SEARCHABLE = 'searchable'
}
export enum FILTER_OPERATORS {
    EQUAL = "eq",
    GREATER_THAN = "gt",
    GREATER_THAN_OR_EQUAL = "gte",
    LESS_THAN = "lt",
    LESS_THAN_OR_EQUAL = "lte",
    CONTAINS = "c",
    NOT_EQUAL = "neq"
  }
  export enum FILTER_LOGICAL_OPERATORS {
    AND = "and",
    OR = "or",
  }
  export enum CAMPAIGN_TYPE {
    EMAIL = 1,
    WHATSAPP = 2
  };
  export enum LOCAL_STORAGE_KEYS {
    SELECTED_PIPELINE = "selectedPipeline",
    SELECTED_ACTIVITY_VIEW = 'selectedActivityView',
    ACTIVITY_LIST_VIEW = 'activityListView',
    IS_SIDE_BAR_EXPANDED = 'isSideBarExpanded',
    CAMPAIGN_CONTACT_ADDRESS = 'contactAddress',
    CALENDAR_VIEW_INDEX = 'calendarViewIndex',
    SELECTED_DEAL_DAY_FILTER = "selectedDealDayFilter",
    SELECTED_DEAL_VIEW = "selectedDealView",
    NEW_EMAIL_AUTOMATION_CAMPAIGN = "newEmailAutomationCampaign",
    NEW_EMAIL_AUTOMATION_LANDING_PAGE = "newEmailAutomationLandingPage",
    SELECTED_ACCOUNT_VIEW = 'selectedAccountView'
  }